import { memo } from "react";
import { Handle, Position, NodeProps } from "@xyflow/react";
import {
  StyledActionNode,
  StyledActionNodeContent,
  StyledNodeAddButton,
  StyledNodeDeleteButton,
  StyledNodeDetail,
  StyledNodeHover,
  StyledNodeTitle,
} from "./index.styled";
import { MessageBotNodeData, MessageBotNodesEnum } from "@lib/types/MessageBot";
import { useTypedDispatch } from "@lib/redux";
import { deleteNode, setAddNodeModal } from "@lib/redux/slices/messageBot";
import { messageBotNodeInfos } from "@lib/constants/MessageBot";

const ActionNode = (props: NodeProps) => {
  const dispatch = useTypedDispatch();
  const { selected, id, type } = props;
  const nodeInfos = messageBotNodeInfos[MessageBotNodesEnum.ACTION];
  const { label } =
    props.data as MessageBotNodeData<MessageBotNodesEnum.ACTION>;

  return (
    <>
      <StyledActionNode selected={selected}>
        <Handle type="target" position={Position.Top} />
        <Handle type="target" position={Position.Left} />
        <Handle type="source" position={Position.Bottom} />
        <Handle type="target" position={Position.Right} />

        <StyledActionNodeContent
          selected={selected}
          width={nodeInfos.size.width}
          height={nodeInfos.size.height}
        >
          <StyledNodeTitle>{type}</StyledNodeTitle>
          <StyledNodeDetail>{label}</StyledNodeDetail>

          <StyledNodeHover className="node-actions">
            <StyledNodeDeleteButton
              size={8}
              onClick={() => {
                dispatch(deleteNode(id));
              }}
            />

            <StyledNodeAddButton
              size={8}
              onClick={() =>
                dispatch(
                  setAddNodeModal({
                    isOpen: true,
                    parentId: id,
                  }),
                )
              }
            />
          </StyledNodeHover>
        </StyledActionNodeContent>
      </StyledActionNode>
    </>
  );
};

export default memo(ActionNode);
